var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const LOCAL_STORAGE_CONVERSION_KEY_UUID = "paak-ad-uuid";
const LOCAL_STORAGE_CONVERSION_KEY_RESPONSE_RECORDS = "paak-ad-response-records";
const SESSION_STORAGE_KEY = "paak-ad-session-time";
export class PaakConversionPageLoader {
    constructor({ backendEndpoint = "https://ad.raund.net", backendApiKey, isSetScript = true, isDebug = false, }) {
        // options
        this.backendEndpoint = backendEndpoint;
        this.backendApiKey = backendApiKey;
        this.isSetScript = isSetScript;
        this.isDebug = isDebug;
        // state
        this.isLoaded = false;
        this.uuidFromLocalStorage = [];
        this.sessionTime = null;
        this.latitude = null;
        this.longitude = null;
    }
    load() {
        // common behavior
        if (this.isLoaded)
            return this;
        this.uuidFromLocalStorage = this.getLocalStorageItem(LOCAL_STORAGE_CONVERSION_KEY_UUID);
        this.sessionTime = this.getSessionStorageItem();
        // on HTML behavior
        if (this.isSetScript) {
            this.setScript();
        }
        return this;
    }
    loadWithGeo() {
        return __awaiter(this, void 0, void 0, function* () {
            this.load();
            const isGeoLocationAccessAllowed = yield this.checkGeoLocationPermission();
            if (isGeoLocationAccessAllowed) {
                const { latitude, longitude } = yield this.accessGeoLocation();
                this.latitude = latitude;
                this.longitude = longitude;
            }
            return this;
        });
    }
    checkGeoLocationPermission() {
        return __awaiter(this, void 0, void 0, function* () {
            if (navigator.permissions) {
                const result = yield navigator.permissions.query({ name: "geolocation" });
                if (result.state === "granted") {
                    return true;
                }
            }
            return false;
        });
    }
    accessGeoLocation() {
        return __awaiter(this, void 0, void 0, function* () {
            if (typeof navigator !== "undefined" && navigator.geolocation) {
                return new Promise((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition((position) => {
                        const latitude = position.coords.latitude.toString();
                        const longitude = position.coords.longitude.toString();
                        resolve({ latitude, longitude });
                    }, (error) => {
                        resolve({ latitude: null, longitude: null });
                    });
                });
            }
            else {
                console.error("Geolocation is not supported by this browser.");
                return { latitude: null, longitude: null };
            }
        });
    }
    setScript() {
        const script = document.createElement("script");
        script.async = true;
        script.onload = () => {
            this.isLoaded = true;
            console.log("Paak-SDK script loaded successfully");
        };
        script.onerror = () => {
            console.error("Failed to load Paak-SDK script");
        };
    }
    // データの読み込みとエラーハンドリング
    getLocalStorageItem(key) {
        const jsonString = localStorage.getItem(key);
        if (jsonString) {
            try {
                return JSON.parse(jsonString);
            }
            catch (error) {
                console.error("Error parsing JSON:", error);
                return null;
            }
        }
        else {
            return null;
        }
    }
    // データを保存する関数
    setLocalStorageItem(key, value) {
        const jsonString = JSON.stringify(value);
        localStorage.setItem(key, jsonString);
    }
    getSessionStorageItem() {
        const sessionTime = sessionStorage.getItem(SESSION_STORAGE_KEY);
        if (sessionTime) {
            return sessionTime;
        }
        else {
            const unixTime = Math.floor(Date.now() / 1000).toString();
            sessionStorage.setItem(SESSION_STORAGE_KEY, unixTime);
            return unixTime;
        }
    }
    appendLocalStorageItem(key, value) {
        const jsonString = this.getLocalStorageItem(key);
        if (jsonString) {
            jsonString.push(value);
            this.setLocalStorageItem(key, jsonString);
        }
    }
    fetchAdConversion({ uuid, userId, latitude, longitude, facilityId, }) {
        const url = `${this.backendEndpoint}/api/v1/ad/conversion`;
        const headers = { "Content-Type": "application/json" };
        return fetch(url, {
            method: "POST",
            headers,
            mode: "cors",
            credentials: "include",
            body: JSON.stringify({
                uuid,
                uuids: [],
                app_key: this.backendApiKey,
                user_id: userId,
                referer: document.referrer,
                url: document.referrer,
                latitude,
                longitude,
                session_time: this.sessionTime,
                facility_id: facilityId
            }),
        });
    }
    onConversion(_a) {
        return __awaiter(this, arguments, void 0, function* ({ userId, latitude, longitude, facilityId, }) {
            const { uuidFromLocalStorage } = this;
            const uuid = uuidFromLocalStorage ? uuidFromLocalStorage[0] : null;
            return this.fetchAdConversion({
                uuid,
                userId,
                latitude: latitude || this.latitude,
                longitude: longitude || this.longitude,
                facilityId: facilityId || null,
            })
                .then((res) => __awaiter(this, void 0, void 0, function* () {
                if (res) {
                    const data = yield res.json();
                    const uuid = data.uuid;
                    this.setLocalStorageItem(LOCAL_STORAGE_CONVERSION_KEY_UUID, [uuid]);
                    // デバック用のデータ保持
                    if (this.isDebug) {
                        data["url"] = `${this.backendEndpoint}/api/v1/ad/conversion`;
                        data["dt"] = new Date().toISOString();
                        if (this.getLocalStorageItem(LOCAL_STORAGE_CONVERSION_KEY_RESPONSE_RECORDS)) {
                            this.appendLocalStorageItem(LOCAL_STORAGE_CONVERSION_KEY_RESPONSE_RECORDS, data);
                        }
                        else {
                            this.setLocalStorageItem(LOCAL_STORAGE_CONVERSION_KEY_RESPONSE_RECORDS, [data]);
                        }
                    }
                    // コンバージョン後にリダイレクト設定
                    const redirectUrl = data.redirect;
                    if (redirectUrl && window && window.location) {
                        window.location.href = redirectUrl;
                    }
                }
            }))
                .catch();
        });
    }
}
//# sourceMappingURL=index.js.map